export class WbMasthead {
  constructor() {
    this.init();
  }

  init() {
    return new Promise((resolve, reject) => {
      this.bindListeners();
      this.setSubmenuState();

      resolve();
    });
  }

  bindListeners() {
    this.addSubmenuListener();
    this.addBurgerListener();
  }

  setSubmenuState() {
    const isCorpoPage = document.querySelector('.corpo-menu.current-menu-parent');

    if (isCorpoPage) {
      this.toggleSubMenu(isCorpoPage, 0);
    }
  }

  addSubmenuListener() {
    const _this = this;
    document
      .querySelector('body')
      ._addCustomEventListener('click', '.sub-menu__trigger', _this.toggleSubMenu.bind(_this));
  }

  addBurgerListener() {
    const _this = this;
    document.querySelector('body')._addCustomEventListener('click', '#wb-burger', _this.toggleMenu.bind(_this));
  }

  toggleMenu(e) {
    return new Promise((resolve, reject) => {
      const ele = e.targetElement;
      const menu = document.querySelector('#menu_mobile');
      ele._toggleAriaExpanded();
      menu._toggleAriaExpanded();
      menu._slideToggle().then(resolve);
    });
  }

  toggleSubMenu(e, duration = 0.35) {
    return new Promise((resolve, reject) => {
      const ele = e.targetElement ?? e;
      const parent = ele.closest('.wb-menu__item');
      const submenu = parent.querySelector(':scope > .sub-menu');

      this.closeAllTopLevelElements(ele, duration);

      ele._toggleAriaExpanded();
      parent._toggleAriaExpanded();
      submenu._slideToggle(duration).then(resolve);
    });
  }

  closeAllTopLevelElements(ele, duration = 0.35) {
    const parent = ele?.closest?.('.wb-menu__item') || false;
    const level = ele ? parent.getAttribute('data-level') : 0;
    const parentNav = ele?.closest?.('nav') || ele;

    if (level == 0) {
      parentNav.querySelectorAll('.level-0[aria-expanded="true"] > .sub-menu').forEach((e) => {
        if (e.closest('.level-0') != parent) {
          e._slideUp(duration);
          e.previousElementSibling.setAttribute('aria-expanded', 'false');
          e.closest('.level-0').setAttribute('aria-expanded', 'false');
        }
      });
    }
  }
}

document.addEventListener('readystatechange', (event) => {
  if (document.readyState == 'complete') {
    window.WbTimeline = new WbMasthead();
  }
});
